<template>
  <v-layout column align-center>
    <h1 class="headline font-weight-bold mb-3 text-center primary--text">
      Selecting when you will receive notifications
    </h1>
    <p>
       You can select the time range when you want to receive them.
    </p>
    <span class="caption">
      Select your time range by clicking on the fields labeled "Pick a time." You can click or drag the clock hands. Notice that you can switch between AM and PM with the lower buttons
    </span>
  </v-layout>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
<style scoped>
  >>>img {
    border:1px solid black;
    max-width:100%;
  }

    >>>p {
      margin:0 16px;
      align-self:start;
    }
    >>>span {
      margin:0 16px;
      text-align:center;
    }

  @media screen and (min-width: 600px) {
    >>>img {
          margin:12px;
    }

  }
</style>
